import consumer from './cable';

$(document).ready(() => {
  // This function is executed after 3mn if Doclift does not answer
  function docliftDoesNotAnswer() {
    if (!(typeof(iframe) == 'object')) {
      consumer.disconnect();
      $("#subscriptionStep2").addClass('d-none');
      $("#subscriptionStep3").addClass('d-none');
      $("#subscriptionStep4").addClass('d-none');
      $("#subscriptionStepError").removeClass('d-none');
    }
  };

  function generateUniversignIframe(signerId) {
    const configuration = {};
    const iframeEndpoint = $('#subscriptionStep3').data('universign-iframe-endpoint');
    /**
    * The universignSigInit function add an iframe element as child of element with
    * id attribute equals to containerId parameter, the attribute src is set from
    * the universignUrl variable, it is the url of the website to be integrated in
    * the iframe, the width and height of the iframe will take 100% of its
    * container.
    *
    * @param {string} containerId The id of the element in which we will inject
    * the iframe.
    * @param {string} signerId The identifier of transaction.
    * @param {object} configuration The options list to customize the iframe:
    * * redirectionMode {string} This params have two possible values: IN or OUT,
    * the dafault value is OUT,
    * if the value of this params is equal to OUT the redirection will be done
    * outside the iframe(in website container of the iframe),
    * if the value of this params is equal to ÌN the redirection will be done
    * inside the iframe,
    * if the value of this params is otherwise, an exception will be triggered.
    **/

    universignSigInit('subscriptionStep3', signerId, configuration, iframeEndpoint);
  }

  function generateContractIframe(documentUrl) {
    iframe = document.createElement('iframe');
    iframe.style.width = '100%';
    iframe.style.height = '86%';
    iframe.src = documentUrl;

    $('#subscriptionStep3').prepend(iframe);

    $('.edit_subscription').on('ajax:success', function(event) {
      $('#subscriptionStep3').addClass('d-none');
      $('#subscriptionStep4').removeClass('d-none');
      $('.breadcrumb-element:nth-child(3)').removeClass('current');
      $('.breadcrumb-element:nth-child(3)').addClass('past');
      $('.breadcrumb-element:nth-child(4)').removeClass('next');
      $('.breadcrumb-element:nth-child(4)').addClass('current');
      $('#current_step').text('4');
    });
  }

  let docliftDoesNotAnswerTimer = setTimeout(docliftDoesNotAnswer, 180000);

  if ($('#signature-subscription-id').length) {
    consumer.subscriptions.create(
      { channel: "SignatureChannel", subscription_id: $('#signature-subscription-id').data('id') }, {
      received(data) {
        try {
          if (data.status == 'success') {
            clearTimeout(docliftDoesNotAnswerTimer);

            if (data.e_sign_id !== undefined) {
              generateUniversignIframe(data.e_sign_id);
            } else {
              generateContractIframe(data.document_url)
            }

            // Enable the button to load the contract and display the success message
            $('#contractLoadedButton').prop('disabled', false);
            $('#subscriptionStep2 #step-title').text($('#subscriptionStep2').data('title-in-case-of-doc-ready'));
            $('#subscriptionStep2 #step-image').attr('src', $('#subscriptionStep2').data('image-in-case-of-doc-ready'));
            $('#generatingDocInProgressExplanations').addClass('d-none');
            $('#generatingDocReadyExplanations').removeClass('d-none');

            $('#contractLoadedButton').on('click', (e) => {
              $('#subscriptionStep3').removeClass('d-none');
              $('#subscriptionStep2').addClass('d-none');

              $('.breadcrumb-element:nth-child(2)').removeClass('current');
              $('.breadcrumb-element:nth-child(2)').addClass('past');
              $('.breadcrumb-element:nth-child(3)').removeClass('next');
              $('.breadcrumb-element:nth-child(3)').addClass('current');
              $('#current_step').text('3');
            });
          } else {
            setTimeout(() => {
              $('#subscriptionStep2').addClass('d-none');
              $('#subscriptionStep3').addClass('d-none');
              $('#subscriptionStep4').addClass('d-none');
              $('#subscriptionStepError').removeClass('d-none');
            }, 5000);
          }
        } catch {
          setTimeout(() => {
            $('#subscriptionStep2').addClass('d-none');
            $('#subscriptionStep3').addClass('d-none');
            $('#subscriptionStep4').addClass('d-none');
            $('#subscriptionStepError').removeClass('d-none');
          }, 5000);
        }
      },
      rejected() {
        setTimeout(() => {
          $('#subscriptionStep2').addClass('d-none');
          $('#subscriptionStep3').addClass('d-none');
          $('#subscriptionStep4').addClass('d-none');
          $('#subscriptionStepError').removeClass('d-none');
        }, 5000);
        this.uninstall();
      },
    }
    );
  };
});
